import { render, staticRenderFns } from "./traffic-jam.vue?vue&type=template&id=0773707a&scoped=true&"
import script from "./traffic-jam.vue?vue&type=script&lang=ts&"
export * from "./traffic-jam.vue?vue&type=script&lang=ts&"
import style0 from "./traffic-jam.vue?vue&type=style&index=0&id=0773707a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773707a",
  null
  
)

export default component.exports